var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionOsmandProLogoColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C11 2 12.8744 3.37886 16 3C16.8233 2.90021 17.8596 2.63794 18.6711 2.40704C19.3285 2.21999 20 2.70711 20 3.39057V15.5617C20 16.421 19.4518 17.1861 18.6249 17.4201C17.8206 17.6478 16.8078 17.9021 16 18C12.8744 18.3789 11 17 8 17V21C8 21.5523 7.55228 22 7 22H5C4.44772 22 4 21.5523 4 21V5V3.53078C4 3.07191 4.31203 2.6709 4.75596 2.55476C5.81963 2.27649 6.90258 2 8 2Z",
    fill: "url(#paint0_linear_2304_9691)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5C7.91769 5.5 7.74026 5.5171 7.5 5.54883V13.5H8C10.0084 13.5 11.686 13.9775 12.7725 14.2393C13.9011 14.5112 14.6547 14.6374 15.5791 14.5254L16.0176 14.4551C16.1687 14.4266 16.3307 14.3921 16.5 14.3535V6.46289L16.4209 6.47461C14.2198 6.74136 12.4727 6.36773 11.1328 6.04492C9.75088 5.71199 8.99137 5.5 8 5.5Z",
    fill: "url(#paint1_linear_2304_9691)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2304_9691",
    x1: 20,
    y1: 11,
    x2: 4,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A379EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817308,
    stopColor: "#844CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336538,
    stopColor: "#5714CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#844CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5714CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2304_9691",
    x1: 7.5,
    y1: 9.55307,
    x2: 16.5,
    y2: 9.55307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725962,
    stopColor: "#CC9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC30D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionOsmandProLogoColored);
export default __webpack_public_path__ + "static/media/ic_action_osmand_pro_logo_colored.cdfa20e3a362e86c88f3fc87f1d052bc.svg";
export { ForwardRef as ReactComponent };